export const ArticleCommentList = {
  CommentName: 'comment-name',
  CommentDate: 'comment-date',
  CommentText: 'comment-text',
};
